import Link from 'next/link';
import { memo, type ReactNode } from 'react';

import { Air } from '@air/next-icons';
import { VisuallyHidden } from '@air/primitive-visually-hidden';

import { Routes } from '~/constants/routes';

export const RedirectToExternalContainer = memo(({ children }: { children: ReactNode }) => (
  <section className="relative flex size-full items-center justify-center bg-grey-3 text-center">
    <div className="flex w-full flex-col bg-white p-6 shadow-xl md:w-[480px] md:rounded-12 dark:bg-black">
      <header className="m-0 box-border flex h-[70px] w-full min-w-0 flex-col items-center">
        <Link href={Routes.root}>
          <VisuallyHidden>Go back to landing page.</VisuallyHidden>
          <Air className="w-[76px] text-grey-12" aria-hidden="true" />
        </Link>
      </header>
      <div className="flex flex-col items-center justify-center p-5">{children}</div>
    </div>
  </section>
));

RedirectToExternalContainer.displayName = 'RedirectToExternalContainer';
